import React, { Component } from "react";
import { PageTitle, LoadingSpinner, AdminNotesModal, TruncatedCell } from "../../common";
import { useApiRequests } from "../../services";
import { renderRequestType } from "../../services/utils/presenter";
import "./styles.scss";

const isAdminNotesEnabled = process.env.REACT_APP_FEATURE_ADMIN_NOTES === 'true';

export class Requests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allRequests: [],
      requestKudosTypesValues: {},
      isDataFetching: true,
      isLoading: false,
      isModalOpen: false,
      currentUserType: localStorage.getItem('userType'),
      selectedEmployee: null,
      isNotesModalOpen: false,
      selectedRequest: null,
      actionType: null,
    };
    this.fetchRequestsData = this.fetchRequestsData.bind(this);
    this.handleEmployeeChange = this.handleEmployeeChange.bind(this);
    this.handleOpenNotesModal = this.handleOpenNotesModal.bind(this);
    this.handleCloseNotesModal = this.handleCloseNotesModal.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
  }

  async fetchRequestsData() {
    const { getAllRequests, getRequestKudosTypesValuesById } = useApiRequests();
    const response = await getAllRequests();
    const allRequests = response.data;

    const requestKudosTypesValues = {};
    const promises = allRequests.map(async (request) => {
      if (request.requestTypeId === 3) {
        const kudosTypeValueResponse = await getRequestKudosTypesValuesById(request.requestKudosTypeValueId);
        requestKudosTypesValues[request.requestKudosTypeValueId] = kudosTypeValueResponse.data.name;
      }
    });

    await Promise.all(promises);

    this.setState({
      allRequests,
      requestKudosTypesValues,
      isDataFetching: false,
      isLoading: false,
    });
  }

  componentDidMount() {
    this.fetchRequestsData();
  }

  handleModalToggle(event) {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  }

  async handleDirectApprove(requestTypeId, id) {
    try {
      const apiRequests = useApiRequests();
      const response = await apiRequests.approveRequestByTypeAndId(requestTypeId, id);
      if (response.status === 200) {
        this.setState({ isLoading: true, isModalOpen: false }, () => {
          setTimeout(() => {
            this.setState({ isLoading: false, isEditFormOpenned: false, isFormOpenned: true });
            this.fetchRequestsData();
          }, 200);
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  async handleDirectDecline(requestTypeId, id) {
    try {
      const apiRequests = useApiRequests();
      const response = await apiRequests.rejectRequestByTypeAndId(requestTypeId, id);
      if (response.status === 200) {
        this.setState({ isLoading: true, isModalOpen: false }, () => {
          setTimeout(() => {
            this.setState({ isLoading: false, isEditFormOpenned: false, isFormOpenned: true });
            this.fetchRequestsData();
          }, 200);
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  handleOpenNotesModal(request, actionType) {
    this.setState({
      isNotesModalOpen: true,
      selectedRequest: request,
      actionType: actionType,
    });
  }

  handleCloseNotesModal() {
    this.setState({
      isNotesModalOpen: false,
      selectedRequest: null,
      actionType: null,
    });
  }

  async handleConfirmAction(adminNotes) {
    const { selectedRequest, actionType } = this.state;

    if (!selectedRequest || !actionType) {
      return;
    }

    try {
      const apiRequests = useApiRequests();
      let response;

      if (actionType === "approve") {
        response = await apiRequests.approveRequestByTypeAndId(
          selectedRequest.requestTypeId,
          selectedRequest.id,
          adminNotes
        );
      } else {
        response = await apiRequests.rejectRequestByTypeAndId(
          selectedRequest.requestTypeId,
          selectedRequest.id,
          adminNotes
        );
      }

      if (response.status === 200) {
        this.setState({
          isLoading: true,
          isNotesModalOpen: false,
          selectedRequest: null,
          actionType: null,
        }, () => {
          setTimeout(() => {
            this.setState({
              isLoading: false,
              isEditFormOpenned: false,
              isFormOpenned: true,
            });
            this.fetchRequestsData();
          }, 200);
        });
      }
    } catch (error) {
      console.log(error.message);
      this.handleCloseNotesModal();
    }
  }

  handleEmployeeChange(event, value) {
    this.setState({ selectedEmployee: value });
  }

  renderRequestType(requestTypeId) {
    if (requestTypeId === 1) {
      return <td>{"Person to person"}</td>;
    }
    if (requestTypeId === 2) {
        return <td>{"Product"}</td>;
    }
    if (requestTypeId === 3) {
      return <td>{"Kudos request"}</td>;
  }
  }

  renderRequestDescription(request) {
    const { requestKudosTypesValues } = this.state;
    switch (request.requestTypeId) {
      case 1:
        return `${request.senderFullName} (${request.senderAmountOfKudos}) kudos would like to send ${request.kudosToTransfer} kudos to ${request.receiverFullName} (${request.receiverAmountOfKudos}) with comment: ${request.description}`;
      case 2:
        return `${request.receiverFullName} (${request.receiverAmountOfKudos}) kudos would like to buy ${request.productName} for ${request.productPrice} kudos, with comment: ${request.description}`;
      case 3:
        const requestKudosTypeValue = requestKudosTypesValues[request.requestKudosTypeValueId];
        return `${request.receiverFullName} (${request.receiverAmountOfKudos}) kudos would like to get ${request.kudosToTransfer} kudos because of: ${requestKudosTypeValue} with comment: ${request.description}`;
      default:
        return "Unknown request type";
    }
  }

  renderRequestStatus(requestStatusId) {
    if (requestStatusId === 1) {
      return <td>{"Pending"}</td>;
    }else if(requestStatusId === 2){
      return <td>{"Approved"}</td>;
    }
     else {
      return <td>{"Rejected"}</td>;
    }
  }

  render() {
    const { isDataFetching, allRequests, isNotesModalOpen, selectedRequest, actionType } = this.state;

    const renderRequestsTable = isDataFetching ? (
      <LoadingSpinner message="Loading..." />
    ) : (
      <>
        <PageTitle title="Requests" />
        <div className="col-12">
          <div className="shadow-50">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Request type</th>
                  <th>Description</th>
                  <th>Status</th>
                  {isAdminNotesEnabled && <th>Admin Notes</th>}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {allRequests.map(request => {
                  const description = this.renderRequestDescription(request);
                  return (
                  <tr key={request.uniqueId}>
                    <td>{request.date}</td>
                    {this.renderRequestType(request.requestTypeId)}
                    <td className="request-description-cell"><TruncatedCell text={description} /></td>
                    {this.renderRequestStatus(request.requestStatusId)}
                    {isAdminNotesEnabled && (
                      <td className="admin-notes-cell">
                        {request.adminNotes ? (
                          <TruncatedCell text={request.adminNotes} />
                        ) : (
                          <span className="no-notes">-</span>
                        )}
                      </td>
                    )}
                    <td>
                      {request.requestStatusId === 1 && (
                        <>
                          <button
                            onClick={() => isAdminNotesEnabled
                              ? this.handleOpenNotesModal(request, "approve")
                              : this.handleDirectApprove(request.requestTypeId, request.id)}
                            className="btn btn-primary mr-2"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => isAdminNotesEnabled
                              ? this.handleOpenNotesModal(request, "reject")
                              : this.handleDirectDecline(request.requestTypeId, request.id)}
                            className="btn btn-danger"
                          >
                            Decline
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {isAdminNotesEnabled && (
          <AdminNotesModal
            isOpen={isNotesModalOpen}
            actionType={actionType}
            requestDescription={selectedRequest ? this.renderRequestDescription(selectedRequest) : ""}
            onConfirm={this.handleConfirmAction}
            onCancel={this.handleCloseNotesModal}
          />
        )}
      </>
    );

    return <>{renderRequestsTable}</>;
  }
}
